import {
  type AnalyticsSourceName,
  flowErrorAttributes,
  operationAttributes,
  type TransferFailure,
  type TransferStep,
} from 'features/feeBasedInstantTransfer/helpers/analyticsFormatters';
import {
  TRANSFER_MONEY_FLOW_ERROR_ENCOUNTERED,
  TRANSFER_MONEY_REQUEST_COMPLETED,
} from 'shared/analytics/events/transferMoney';
import type { VaroEvent } from 'shared/analytics/types/events';
import { useAnalytics } from 'shared/hooks/analytics/useAnalytics';

type TransferAttributes = Record<string, unknown>;

/** Logs FBIT track events from one screen; formatting stays in analyticsFormatters. */
export default function useTransferAnalytics(sourceName: AnalyticsSourceName) {
  const { logEvent } = useAnalytics();

  const logTransferEvent = (
    event: VaroEvent,
    attributes: TransferAttributes = {},
  ) => {
    void logEvent(event, { source_name: sourceName, ...attributes });
  };

  const logFlowError = (
    step: TransferStep,
    failure: TransferFailure,
    transferAttributes: TransferAttributes = {},
  ) => {
    logTransferEvent(TRANSFER_MONEY_FLOW_ERROR_ENCOUNTERED, {
      ...transferAttributes,
      ...flowErrorAttributes(step, failure),
    });
  };

  const logRequestCompleted = (
    ...operation: Parameters<typeof operationAttributes>
  ) => {
    logTransferEvent(
      TRANSFER_MONEY_REQUEST_COMPLETED,
      operationAttributes(...operation),
    );
  };

  return { logTransferEvent, logFlowError, logRequestCompleted };
}
